











import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class CardTitle extends Vue {
  @Prop(String)
  title!: string
}
